import { FormProvider } from '@slal/ui/react-hook-form/core';
import { Field, FieldSet, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { Article, Heading, P } from '@slal/ui/typography';
import { MaxWidthContent, StyledForm, yesOrNoOptions } from '~/components';
import { ApplicationButtons } from '~/features';
import { useKeyConsiderationsApplicationForm } from './hooks';
import { SelectedYesNoContent } from './SelectedYesNoContent';

const YesContent = () => {
    return (
        <Article>
            <Heading level={5}>
                That's good. But did you know that you may be targeted by people you know as well as criminals or
                scammers?
            </Heading>
            <P>
                When you choose to have flexible access to your pension, you may be offered high return investment
                opportunities or deals that are not what they seem.
            </P>
            <P markdown>
                Never feel rushed into making a decision. The common signs to look out for can be found on the
                government's [Pension Scams](https://www.thepensionsregulator.gov.uk/pension-scams) website.
            </P>
        </Article>
    );
};

const NoContent = () => {
    return (
        <Article>
            <Heading level={5}>That's ok, we can tell you about them.</Heading>
            <P>
                You need to know that when you choose to have flexible access to your pension, you may be targeted by
                criminals, scammers or even people you know offering high return investment opportunities or deals that
                are not what they seem.
            </P>
            <P markdown>
                Never feel rushed into making a decision. Support on how to protect yourself, as well as the common
                signs to look out for, can be found on the government's [Pension
                Scams](https://www.thepensionsregulator.gov.uk/pension-scams) website.
            </P>
        </Article>
    );
};

export const InvestmentScamsForm = () => {
    const { form, handleSubmit, name, option } = useKeyConsiderationsApplicationForm(
        'investmentScams',
        '/application/key-considerations/outstanding-debts'
    );

    return (
        <MaxWidthContent>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit}>
                    <FieldSet aria-label="Investment scams">
                        <Field errorFor={name}>
                            <RadioFieldGroup name={name} options={yesOrNoOptions} stacked />
                        </Field>
                    </FieldSet>
                    {option && (
                        <SelectedYesNoContent option={option} YesContent={<YesContent />} NoContent={<NoContent />} />
                    )}
                    <ApplicationButtons backTo="/application/key-considerations/health-issues" />
                </StyledForm>
            </FormProvider>
        </MaxWidthContent>
    );
};
